import { render, staticRenderFns } from "./Static.vue?vue&type=template&id=09b4b7fc&scoped=true&"
import script from "./Static.vue?vue&type=script&lang=ts&"
export * from "./Static.vue?vue&type=script&lang=ts&"
import style0 from "./Static.vue?vue&type=style&index=0&id=09b4b7fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b4b7fc",
  null
  
)

export default component.exports